module.exports = __webpack_public_path__ + "static/16-c9100e51384c85733c426ff503b6dc8d.jpeg";